module.exports = __webpack_public_path__ + "img/vocational-rehabilitation-referral-back.f09dc90c.svg";